module.exports = __webpack_public_path__ + "img/jwt.8dd411e1.png";